<template>
    <span class="y-btn__total" v-if="getLocalCount > 0">{{getLocalCount}}</span>
</template>

<script>
    export default {
        name: "ContMessage",
        data(){
            return {
              local_count: ''
            }
        },
        props: {
            count: '',

        },
        created() {
        },
        computed:{
            getLocalCount: function (){
                return this.$root.storage.global_count;
            }
        },
        mounted() {
            this.$root.storage.global_count = this.count;
            this.local_count = this.$root.storage.global_count;

        }
    }
</script>
